export default [

     {
          path: '/glossary',
          name: 'Glossary',
          component: () => import("@/views/Page/Glossary/Glossary.vue"),
           meta: {
               title: 'Glossary',
          },
     }
];